import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var TimeseriesIcon = function TimeseriesIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "TimeseriesIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4.542 6.74a.933.933 0 0 1 1.381 0l2.565 2.74 2.566-2.74a.933.933 0 0 1 1.38 0 1.094 1.094 0 0 1 0 1.476L9.18 11.694a.933.933 0 0 1-1.381 0l-2.565-2.74-2.566 2.74a.933.933 0 0 1-1.38 0 1.095 1.095 0 0 1 0-1.475z",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      d: "M15 5.16c0 .64-.486 1.159-1.085 1.159-.6 0-1.085-.52-1.085-1.16S13.314 4 13.915 4 15 4.52 15 5.16"
    })]
  }));
};

export { TimeseriesIcon };
